import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useGetContributingEntityQuery } from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { ContributingEntityForm } from "./ContributingEntityForm";

export const ContributingEntityPage = () => {
  const { contributingEntityId } = useParams<{ contributingEntityId: string }>();
  const displayer = useApiError();

  const { data, error } = useGetContributingEntityQuery(
    { entityId: contributingEntityId ?? "" },
    { skip: !contributingEntityId },
  );

  if (error) return displayer.show(error);

  if (!contributingEntityId || !data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  return (
    <PortalLayout>
      <ContributingEntityForm key={contributingEntityId} entityId={contributingEntityId} detail={data} />
    </PortalLayout>
  );
};
